import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "icon" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "progress" }


  import { type ExposureLog } from '@/types';
  
  
export default /*@__PURE__*/_defineComponent({
  __name: 'DishListItem',
  props: {
    id: {},
    title: {},
    goal: {},
    progress: {},
    foodId: {},
    logs: {},
    expanded: { type: Boolean }
  },
  setup(__props: any) {


  const props = __props;

  
return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: '/dish/'+_ctx.id,
    class: "item"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_font_awesome_icon, {
          icon: ['fal', 'bowl-food'],
          class: "fa-lg"
        })
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.title), 1),
        _createElementVNode("small", _hoisted_3, "Progress: " + _toDisplayString(_ctx.progress) + "/" + _toDisplayString(_ctx.goal), 1)
      ]),
      _createVNode(_component_font_awesome_icon, {
        class: "chevron-icon fa-sm",
        icon: ['fas', 'chevron-right']
      })
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})